import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import { getDayjsLocale, getDefaultLanguage } from '../../../Services/LanguageService';
import { GDPR_VALUE, NOT_AVAILABLE_VALUE, OFF_VALUE, PAID_VALUE } from '../../CmdTable/constants';
import { ITripsOverViewRecord } from '../interfaces';

interface ITimeStampProps {
  data: ITripsOverViewRecord;
  datacyIndex: number;
}

function TimeStamp(props: ITimeStampProps) {
  const { formatMessage: f } = useIntl();
  const defaultLanguage = getDefaultLanguage();

  const handleAnonymizedTime = (value: string): JSX.Element | string => {
    switch (value) {
      case GDPR_VALUE:
        return ` ${f({ id: 'tables.tripsOverview.column.datetime.anonymized' })}`;
      case PAID_VALUE:
        return <>&ndash;</>;
      case OFF_VALUE:
        return <>&ndash;</>;
      case NOT_AVAILABLE_VALUE:
        return <>&ndash;</>;

      default:
        return ` ${dayjs(value)
          .locale(getDayjsLocale(defaultLanguage))
          .format('D.M.YYYY H:mm:ss')}`;
    }
  };

  return (
    <div
      style={{
        whiteSpace: 'nowrap',
        minWidth: '140px',
        flex: 1,
      }}
    >
      <div>
        <div data-cy={`row-${props.datacyIndex + 1}-Datetime_Start`}>
          <span className="e-dot e-dot--sm e-dot--green" />
          {` ${dayjs(props.data.timestamp.start)
            .locale(getDayjsLocale(defaultLanguage))
            .format('D.M.YYYY H:mm:ss')}`}
        </div>
        <div data-cy={`row-${props.datacyIndex + 1}-Datetime_End`} className="mt-1">
          <span className="e-dot e-dot--sm e-dot--red" />
          {handleAnonymizedTime(props.data.timestamp.end)}
        </div>
      </div>
    </div>
  );
}

export default TimeStamp;
